<template>
    <div>
      <carousel :perPage="1" :paginationEnabled="false">
        <slide>
          <div>
            <p>Dear Suzie,</p>
            <p fade-auto="suza">how is your new job going? just writing about Oska's birthday party next week, and hoping you can help actually! I thought i'd found the perfect location yesterday, really friendly and plenty of space for them to run around . . . couldn't really believe i've never seen it before, it was right by the glass hall just off Four-head, by the steps to the plusten, a few metal tables and chairs outside (with no rain cover on those though which seemed a little strange) . .</p>

            <p fade-auto="suzb">Anyway i'm wondering if you know it because i just can't seem to find it now, i did take a photo but of course it's blotted from my mouth now. I can't imagine it's just closed so quickly? let me know if you know what i'm talking about, or if i'm just getting old!</p>

            <p fade-auto="suzc">xx</p>
          </div>
        </slide>
      </carousel>
    </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Dear Suzie'
    }
  },
  mounted () {
    this.$emit('title-update', this.title)
  }
}
</script>

<style lang="css" scoped>
</style>
